/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1      Usha       24/01/2020      1973: Related Symptoms Implementation
*********************************************************************************/
import * as actions from './actions'
export { actions }
